import React from 'react';
import { Button } from '@/components/ui/button';
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';
import { User, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logo from '@/assets/logo-small.webp';
const Header: React.FC = () => {
  const { user, profile, hasPaymentAccess, signOut } = useSupabaseAuth();
  const navigate = useNavigate();

  const isLoggedIn = !!user;

  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
          <img 
            src={logo} 
            alt="Toppers Buddy Logo" 
            className="h-12 w-auto object-contain"
            width={88}
            height={48}
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <span className="text-lg sm:text-xl font-bold">
            <span className="text-gradient">TOPPERS</span>
            <span className="text-foreground"> BUDDY</span>
          </span>
        </div>

        <div className="flex items-center gap-3">
          {isLoggedIn ? (
            <div className="flex items-center gap-3">
              {hasPaymentAccess && (
                <div className="hidden md:flex items-center gap-1 rounded-full bg-gradient-to-r from-gold to-amber-500 px-3 py-1 text-xs font-semibold text-gold-foreground">
                  ⭐ VIP
                </div>
              )}
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => navigate('/dashboard')}
                className="gap-2"
              >
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">Dashboard</span>
              </Button>
              <Button 
                variant="ghost" 
                size="sm"
                onClick={handleLogout}
                className="gap-2 text-muted-foreground hover:text-foreground"
              >
                <LogOut className="h-4 w-4" />
                <span className="hidden sm:inline">Logout</span>
              </Button>
            </div>
          ) : (
            <Button 
              variant="hero" 
              size="sm"
              onClick={() => navigate('/auth')}
              className="gap-2"
            >
              <User className="h-4 w-4" />
              Login / Sign Up
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;